import User from "../../services/User";
import useAuthorizedQuery from "../../common/hooks/useAuthorizedQuery";

export const QUERY_KEY = "users";

function useListUsers() {
  return useAuthorizedQuery(QUERY_KEY, () => User.listUsers());
}

export default useListUsers;
